import 'reflect-metadata';

// export function DoraPropertyArray<T>(doraType: T ) {
//     return (target: any, propertyKey: string | symbol) => {
//         Reflect.defineMetadata('DoraPropertyArray', doraType, target, propertyKey);
//     };
// }

export function DoraPropertyArray(doraType: any ) {
    return (target: any, propertyKey: string | symbol) => {
        Reflect.defineMetadata('DoraPropertyArray', doraType, target, propertyKey);
    };
}

export function DoraProperty(target: any, key: string) {}


